module.exports = __webpack_public_path__ + "static/media/MarioViktorov.b6ed5de4.jpg";